import styled from "../../shared/styled";
import { TreeSelect } from "antd";

export const StyledTreeSelect = styled(({ darkModeActive, ...props }) => (
    <TreeSelect {...props} />
  ))`
    && {
      .ant-select-selector.ant-select-selector {
        overflow-y: auto;
        border-radius: 4px !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }
      .ant-select-clear{
        right:35px !important;
      }
     .ant-select-selection-wrap {
        align-self: center !important;
      }
      .ant-select-multiple.ant-select-lg .ant-select-selection-wrap {
        align-self: center !important;
      }
      .ant-select-multiple .ant-select-selection-wrap {
        align-self: center !important;
      }
      .ant-select-selection-placeholder{
        color: ${({ darkModeActive }) => darkModeActive ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)"} !important;
      }
      .ant-select-arrow{
        color: ${({ darkModeActive }) => darkModeActive ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.6)"} !important;
      }
    }
  `;
